export function mapFilterNullish(arr, fn) {
    return arr.reduce((acc, item, i) => {
        const result = fn(item, i, arr);
        if (result !== null && result !== undefined) {
            acc.push(result);
        }
        return acc;
    }, []);
}
